import { HorizonTabs } from "./dashboardKit";
import type { EnrollmentSnapshotMetrics, EnrollmentTrendRow } from "./enrollmentTypes";
import {
  EnrolledSubtypeChart,
  EodSnapshotPanel,
  ErrorState,
  LoadingState,
  RatesTrendChart,
  RollupTable,
  ScheduledTrendChart,
  SectionDivider,
  SnapshotComparisonChart,
} from "./enrollmentUi";

export function EnrollmentMonthlyTab(props: {
  comparisonLabel: string;
  comparisonSnap: EnrollmentSnapshotMetrics | null;
  effectiveSnapshotDate: string;
  filteredMonthlyRows: EnrollmentTrendRow[];
  monthlyOptions: Array<{ label: string; value: string }>;
  monthlySelectedDate: string;
  monthlySnapshotError: string;
  monthlySnapshotLoading: boolean;
  monthlySnapshotRows: Array<{ aligned: number; label: string; marketablePatients: number }>;
  setMonthlySelectedDate: (date: string) => void;
  snapError: string;
  snapLoading: boolean;
  snapshot: EnrollmentSnapshotMetrics | null;
  trendError: string;
  trendLoading: boolean;
}) {
  return (
    <div className="flex flex-col gap-4">
      {props.trendLoading ? (
        <LoadingState />
      ) : props.trendError ? (
        <ErrorState message={props.trendError} />
      ) : (
        <>
          <div className="flex flex-wrap items-center gap-3">
            <span className="text-sm font-semibold text-foreground">Month:</span>
            <HorizonTabs
              idPrefix="enrollment-month"
              options={props.monthlyOptions.map((option) => ({
                label: option.label,
                value: option.value,
              }))}
              value={props.monthlySelectedDate}
              onChange={props.setMonthlySelectedDate}
            />
          </div>

          <SectionDivider label="EOD snapshot" />
          {props.snapLoading ? (
            <LoadingState />
          ) : props.snapError ? (
            <ErrorState message={props.snapError} />
          ) : (
            <EodSnapshotPanel
              snap={props.snapshot}
              comparisonSnap={props.comparisonSnap}
              date={props.effectiveSnapshotDate}
              comparisonLabel={props.comparisonLabel}
            />
          )}

          <SectionDivider label="Aligned vs marketable patients" />
          {props.monthlySnapshotLoading ? (
            <LoadingState />
          ) : props.monthlySnapshotError ? (
            <ErrorState message={props.monthlySnapshotError} />
          ) : (
            <SnapshotComparisonChart rows={props.monthlySnapshotRows} />
          )}

          {props.filteredMonthlyRows.length > 0 ? (
            <>
              <SectionDivider
                label={`Monthly trend charts (${props.monthlyOptions.length} months)`}
              />
              <div className="flex flex-wrap gap-3">
                <ScheduledTrendChart
                  rows={props.filteredMonthlyRows}
                  xKey="periodStart"
                  xLabel="monthly"
                />
                <RatesTrendChart
                  rows={props.filteredMonthlyRows}
                  xKey="periodStart"
                  xLabel="monthly"
                />
              </div>
              <EnrolledSubtypeChart
                rows={props.filteredMonthlyRows}
                xKey="periodStart"
                xLabel="monthly"
              />
              <SectionDivider label="Monthly detail table" />
              <RollupTable rows={[...props.filteredMonthlyRows].reverse()} xKey="periodStart" />
            </>
          ) : (
            <div className="text-sm text-muted-foreground">No monthly data available.</div>
          )}
        </>
      )}
    </div>
  );
}
